import { render, staticRenderFns } from "./file-manager-widget.vue?vue&type=template&id=a33fd84c&scoped=true"
import script from "./file-manager-widget.vue?vue&type=script&lang=js"
export * from "./file-manager-widget.vue?vue&type=script&lang=js"
import style0 from "./file-manager-widget.vue?vue&type=style&index=0&id=a33fd84c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33fd84c",
  null
  
)

export default component.exports